import type {ReactElement} from 'react';
import React from 'react';
import type {UserAttachmentLightboxHeaderContentProps} from './user-attachment-lightbox-header-content.types';
import styles from './user-attachment-lightbox-header-content.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Button, Size, Type} from '@Components/button';

export function UserAttachmentLightboxHeaderContent({onClose, onReattach, currentImage, currentImageSrc}: UserAttachmentLightboxHeaderContentProps): ReactElement {
  const handleReattach = (): void => {
    onReattach(currentImage, currentImageSrc);
    onClose();
  };

  return (
    <div className={styles.lightboxHeader}>
      <Icon
        icon="icon-arrow-left"
        size={IconSize.SIZE_ICON_16}
        type={IconType.DARK_GHOST}
        ariaLabel={window.i18next.t('pmwjs_back')}
        shape={IconShape.SQUARE}
        onClick={onClose}
        className={styles.backButton}
      />
      <Button text={window.i18next.t('pmwjs_reattach')} size={Size.XSMALL} type={Type.DARK_SECONDARY} icon="icon-paperclip" onClick={handleReattach} />
    </div>
  );
}
